import React from "react";
import styled from "styled-components";

const getVariantStyles = (variant, colCnt, hRowSize, rowCnt, rowSize) => {
    let setGap = "1px 0";
    let vAlign = "flex-start";
    let childSet01 = "2n + 1";
    let childSet02 = "2n";
    let gridTemplateRows = `repeat(${rowCnt}, minmax(${rowSize}, auto))`;

    switch (variant) {
        case "Vertical":
            setGap = "1px";
            vAlign = "center";
            childSet01 = `-n+${colCnt}`;
            childSet02 = `n +${colCnt + 1}`;
            gridTemplateRows = rowCnt <= 1
                ? hRowSize
                : `${hRowSize} repeat(${rowCnt - 1}, minmax(${rowSize}, auto))`;
            break;

        case "Tertiary":
            setGap = "2px 0"; // 예시로 특정한 스타일 적용
            vAlign = "flex-end";
            break;

        case "Outline":
            setGap = "1px 1px";
            vAlign = "center";
            childSet01 = "odd";
            childSet02 = "even";
            break;

        default:
            // 기본값은 이미 설정됨
            break;
    }

    return `
        gap: ${setGap};
        grid-template-rows: ${gridTemplateRows};

        > div {
            display: flex;
            align-items: center;
            justify-content: ${vAlign};
            gap: 8px;
            padding-left: 16px;
            font: 500 16px/1.5 Pretendard;
            color: #1C1C1C;
        }        
        
        > div:nth-child(${childSet01}) {
            background-color: #ECF0F6;
        }
        > div:nth-child(${childSet02}) {
            background-color: #FFFFFF;
            font: 400 15px/1.5 Pretendard;
            > span {
                color: #2979FF;
            }
        }
    `;
};

export const StdDiv = styled.div`
    //margin-top: 8px;
    padding: 1px 0;
    background-color: #E0E0E0;
    display: grid;

    grid-template-columns: ${(props) => (props.$colSize || []).map((size) => `minmax(auto, ${size})`).join(" ")};

    ${(props) => getVariantStyles(props.$variant, props.$colCnt, props.$hRowSize, props.$rowCnt, props.$rowSize)}
    
    .col_merge {
        grid-column-start: ${(props) => (props.$variant === "Vertical" ? 1 : 2)};
        grid-column-end: ${(props) => Math.max(2, props.$colCnt + 1)};
    }
    
    .col_merge2 {
        grid-column-start: ${(props) => (props.$variant === "Vertical" ? 3 : 4)};
        grid-column-end: ${(props) => Math.max(2, props.$colCnt + 1)};
    }
    .flex_column{
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    > div.titleCel {
        background-color: #ECF0F6;
        font: 600 14px/1.5 Pretendard;
    }
    

`;

const Table = (props) => {

    const {
        variant = "default",
        colCnt = 0, rowCnt = 0,
        rowSize , hRowSize= "", colSize=[]
    } = props;

    if (!props.children) return null; // children이 없으면 렌더링하지 않음

    return (
        <StdDiv
            $variant={variant}
            $colCnt={colCnt <= 0 ? colSize?.length || 0 : colCnt}
            $hRowSize={hRowSize || rowSize}
            $rowCnt={rowCnt}
            $rowSize={rowSize}
            $colSize={colSize || []}
        >
            {props.children}
        </StdDiv>
    );
};

export default Table;
